import React from 'react';
import QueryViewer from '../../code/components/query-viewer/QueryViewer';
import { HdButton, HdIconButton, HdPane } from '../../components';
import HdIcon from '../../media/components/icon/HdIcon';
import HdModal from '../../modal/components/modal/HdModal';
import { getDataIdGenerator } from '../../core/utils/generateDataId';

export interface QueryHistoryDialogProps {
  open: boolean;
  lastSavedQuery: string;
  onClose: Function;
}

export function ActivationQueryHistoryDialog({
  open,
  lastSavedQuery,
  onClose
}: QueryHistoryDialogProps) {
  const dataIdGenerator = getDataIdGenerator('activation-query-history-dialog');

  return (
    <HdModal
      open={open}
      onClose={() => onClose()}
      contentClassName='surface-on-surface'
      placement='top'
      styling={{
        width: '800px',
        maxWidth: '100%'
      }}
    >
      <>
        <div
          className='dialog-header dialog-header--absolute'
        >
          <HdIconButton
            onClick={() => onClose()}
            dataId={dataIdGenerator('close')}
          >
            <HdIcon name='close' size={3} />
          </HdIconButton>
        </div>

        <div className='dialog-body'>
          <div className='dialog-title text-subheading-3 mb-2'>Last Saved Query</div>

          <div className='text-body mb-5'>
            This is the query that is currently being used by the Activation.
          </div>

          <QueryViewer
            className='mb-5'
            value={lastSavedQuery}
            dataId={dataIdGenerator('')}
          />

          <HdPane variant='warning-faded' icon='warning' className='mb-5'>
            <div className='text-medium'>
              If you revert to this query, any changes that you made in the SQL QUERY editor will be lost.
            </div>
          </HdPane>

          <div className='center-flex-row justify-end'>
            <HdButton
              variation='outline'
              className='mr-3'
              dataId={dataIdGenerator('cancel')}
              onClick={() => onClose()}
            >
              Cancel
            </HdButton>

            <HdButton
              dataId={dataIdGenerator('submit')}
              onClick={() => onClose(true)}
            >
              Use This Query
            </HdButton>
          </div>
        </div>
      </>
    </HdModal>
  );
}
